//  React TS Base Styles
import colors from '../../base/colors'
import borders from '../../base/borders'
import boxShadows from '../../base/boxShadows'

//  React TS Helper Functions
import pxToRem from '../../functions/pxToRem'

const { grey, white } = colors
const { borderRadius } = borders
const { tabsBoxShadow } = boxShadows

// types
type Types = any

const tabs: Types = {
  styleOverrides: {
    root: {
      position: 'relative',
      backgroundColor: 'var(--dewi_pill_secondary)',
      borderRadius: 'var(--dewi_radius_rounded)',
      minHeight: 'unset',
      padding: pxToRem(4),
    },

    flexContainer: {
      height: '100%',
      position: 'relative',
      zIndex: 10,
    },

    fixed: {
      overflow: 'unset !important',
      overflowX: 'unset !important',
    },

    vertical: {
      '& .MuiTabs-indicator': {
        width: '100%',
      },
    },

    indicator: {
      height: '100%',
      borderRadius: 'var(--dewi_radius_rounded)',
      backgroundColor: white.main,
      boxShadow: 'none',
      transition: 'all 500ms ease',
    },
  },
}

export default tabs
